<template>
	<NuxtLink
		:to="option.route"
		class="size-full"
		@click="navigationStore.closeMenus"
	>
		<PortalHeaderNavMobileOption :class="props.class" :option="option" />
	</NuxtLink>
</template>

<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { type NavDefaultOptionConfig } from '.';
import { useNavigationStore } from '~/store/navigationStore';

const props = defineProps<{
	class?: HTMLAttributes['class'];
	option: NavDefaultOptionConfig;
}>();

const navigationStore = useNavigationStore();
</script>
